import { render, staticRenderFns } from "./MyFavorites.vue?vue&type=template&id=39cfda1d&scoped=true&"
import script from "./MyFavorites.vue?vue&type=script&lang=js&"
export * from "./MyFavorites.vue?vue&type=script&lang=js&"
import style0 from "./MyFavorites.vue?vue&type=style&index=0&id=39cfda1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cfda1d",
  null
  
)

export default component.exports